<main class="success container full-height d-flex flex-column justify-content-center">
  <p class="text-center text-success">
    <i class="fa fa-check-circle fa-4x"></i>
  </p>
  <h3 class="text-center" i18n>Order sent</h3>
  <p class="text-center" i18n>
    Your order #{{ order?.number }} was sent successfully and will be prepared now.
  </p>
  <div *ngIf="host.order_note_2" [innerHTML]="host.order_note_2"></div>
  <p class="text-center" *ngIf="hasEstimatedTime() && isTakeout()">
    <span i18n>Estimated takeout time</span>:&nbsp;{{ getEstimatedTime() }}
  </p>
  <p class="text-center" *ngIf="hasEstimatedTime() && isDelivery()">
    <span i18n>Estimated delivery time</span>:&nbsp;{{ getEstimatedTime() }}
  </p>
  <p class="text-center" i18n *ngIf="showPaymentNotice()">
    Please pay the total price of {{ order.total|currency:host }} on
    <span *ngIf="isDelivery()">delivery</span>
    <span *ngIf="isTakeout()">pickup</span>.
  </p>
  <p class="text-center" i18n *ngIf="showAlreadyPaidNotice()">
    Your order has already been paid online.
  </p>
  <p class="text-center" *ngIf="willGetEmail()" i18n>We'll send an email to {{ order.data.address.email }} to confirm your order.</p>
  <p class="text-center">
    <button *ngIf="canClose()" (click)="onBtClose($event)" class="btn btn-primary" i18n>Close this window and go back to {{host.name}}</button>
    <button *ngIf="!canClose()" (click)="onBtClose($event)" class="btn btn-primary" i18n>Go back to {{host.name}}</button>
  </p>
</main>
